export default "__VITE_ASSET__DFwb_pPs__"